import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import types from '../../actions/types'
import {get} from 'lodash'

export const stageId = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.stageId', state)
    default:
      return state
  }
}

export const status = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.status', state)
    default:
      return state
  }
}

export const orderReasons = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.orderReasons', state)
    default:
      return state
  }
}

export const rejectReasons = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.rejectReasons', state)
    default:
      return state
  }
}

export const companies = (state = [], action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.companies', state)
    default:
      return state
  }
}

export const users = (state = [], action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.users', state)
    default:
      return state
  }
}

export const jobTypes = (state = [], action) => {
    switch (action.type) {
        case types.OPPORTUNITY_UPDATE_FILTERS:
            return get(action, 'filters.jobTypes', state)
        default:
            return state
    }
}

export const dateTypes = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.dateTypes', state)
    default:
      return state
  }
}

export const timeKey = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.timeKey', state)
    default:
      return state
  }
}

export const targetStart = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.targetStart', state)
    default:
      return state
  }
}

export const targetEnd = (state = null, action) => {
  switch (action.type) {
    case types.OPPORTUNITY_UPDATE_FILTERS:
      return get(action, 'filters.targetEnd', state)
    default:
      return state
  }
}

export const salesContextOpportunitiesPivotTableKey = 'salesContext.opportunitiesView.opportunities'

export default combineReducers({
    stageId,
    status,
    rejectReasons,
    orderReasons,
    companies,
    users,
    jobTypes,
    dateTypes,
    timeKey,
    targetStart,
    targetEnd,
    opportunities: createPivotTableReducer({key: salesContextOpportunitiesPivotTableKey, defaultSortColumn: 'createdDate', defaultSortDirection: 'desc'}),
})
